import { Record, Union } from "../../../fable_modules/fable-library-js.4.19.0/Types.js";
import { record_type, class_type, string_type, union_type } from "../../../fable_modules/fable-library-js.4.19.0/Reflection.js";
import { FSharpResult$2 } from "../../../fable_modules/fable-library-js.4.19.0/Result.js";
import { Remote$1, Remote$1_$reflection } from "../../../../Bfs.Web.Portale/Types.fs.js";

export class Page extends Union {
    constructor() {
        super();
        this.tag = 0;
        this.fields = [];
    }
    cases() {
        return ["VersionInfo"];
    }
}

export function Page_$reflection() {
    return union_type("Admin.Types.Page", [], Page, () => [[]]);
}

export class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["GetServerVersion", "ServerVersionLoaded"];
    }
}

export function Msg_$reflection() {
    return union_type("Admin.Types.Msg", [], Msg, () => [[], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [string_type, class_type("System.Exception")], FSharpResult$2, () => [[["ResultValue", string_type]], [["ErrorValue", class_type("System.Exception")]]])]]]);
}

export class Model extends Record {
    constructor(ClientVersion, ServerVersion) {
        super();
        this.ClientVersion = ClientVersion;
        this.ServerVersion = ServerVersion;
    }
}

export function Model_$reflection() {
    return record_type("Admin.Types.Model", [], Model, () => [["ClientVersion", string_type], ["ServerVersion", Remote$1_$reflection(string_type)]]);
}

export function Model_get_Init() {
    return new Model(__BUILD_VERSION__, new Remote$1(1, []));
}

//# sourceMappingURL=Types.fs.js.map
